import i18next from 'i18next';
import i18nextHttpApi from 'i18next-http-backend';
import { getWhitelabelName } from 'web-app/shared/white-labeling-helpers';
import { baseTranslationsOnly } from 'web-app/setup/base-translations-only';
import { DEFAULT_NAMESPACE, translationsLoadPath } from 'web-app/setup/translations-load-path';
import { runtimeFallbackLanguages } from 'web-app/setup/runtime-fallback-languages';
export const SUPPORTED_LANGUAGES = ['da-DK', 'en-US', 'en-GB', 'de-DE', 'eo-UY', 'en-JM', 'no-NO', 'es-ES', 'nl-NL'];
const setup = async (templatePath, { eagerNamespaces = [DEFAULT_NAMESPACE], language, completedLanguages = [] } = {}) => {
    // Read once, so which catalogue the session renders cannot change between two namespace loads
    // and leave a page half in the base copy and half in the account's language.
    const serveBaseCatalogue = baseTranslationsOnly();
    const options = {
        compatibilityJSON: 'v4',
        ns: eagerNamespaces,
        defaultNS: DEFAULT_NAMESPACE,
        partialBundledLanguages: true,
        interpolation: {
            escapeValue: false,
            // In v21 "skipOnVariables" defaults to true
            // As we are using nested translations keys
            // we are changing it to false
            // https://www.i18next.com/misc/migration-guide#skiponvariables-true
            skipOnVariables: false,
            defaultVariables: {
                whitelabelName: getWhitelabelName(),
            },
        },
        lng: language,
        fallbackLng: runtimeFallbackLanguages(new Set(completedLanguages)),
        load: 'currentOnly',
        supportedLngs: SUPPORTED_LANGUAGES,
        backend: {
            crossDomain: false,
            withCredentials: false,
            loadPath: (_lngs, namespaces) => {
                const ns = namespaces[0];
                if (namespaces.length > 1) {
                    console.warn('Loading multiple namespaces at once is not supported! Found: ', namespaces.join(', '));
                }
                return translationsLoadPath({
                    templatePath,
                    namespace: ns,
                    baseTranslationsOnly: serveBaseCatalogue,
                });
            },
        },
    };
    return await i18next.use(i18nextHttpApi).init(options);
};
export default setup;
